export const ragamData = [
    {
        id: 1,
        namaOspek: "PKKMB FKH 2021",
        desc: "PROBINMABA (Program Pembinaan Mahasiswa Baru) merupakan sebuah program dalam upaya pembinaan Mahasiswa Baru Fakultas Kedokteran Hewan Universitas Brawijaya yang diadakan rutin setiap tahunnya. PROBINMABA FKH UB memiliki dua rangkaian yakni PKKMABA (Pengenalan Kehidupan Kampus) dan KRIMA (Krida Mahasiswa). PROBINMABA FKH UB mengangkat sebuah tema yakni “Aktualisasi Pembentukan Pribadi Mahasiswa Baru yang Berintegritas Tinggi Sesuai Keprofesian Dokter Hewan”.",
        sosmed: [
            ["https://www.instagram.com/maba_fkhubofficial/", "instagram"],
        ],
        img: "fkh",
    },
    {
        id: 2,
        namaOspek: "PKKMABA FIB",
        desc: "PKKMABA FIB 2021 adalah sebuah sarana bagi para mahasiswa baru dalam mengenal kehidupan kampus, khusunya Fakultas Ilmu Budaya secara lebih jauh. Adapun tujuan diadakannya PKKMABA FIB 2021 adalah untuk memberi pengenalan yang layak kepada para mahasiswa tentang kehidupan kampus agar mahasiswa baru bisa beradaptasi dengan baik dan dapat menjadi mahasiswa yang religius, kreatif, inovatif, dan juga memiliki sense of belonging terhadap fakultasnya, serta rasa bangga dan semangat untuk membangun dan menjadikan Fakultas Ilmu Budaya menjadi lebih baik.",
        sosmed: [
            ["https://www.instagram.com/pkkmabafibub/", "instagram"],
            ["http://pkkmabafibub.com", "website"],
            [
                "https://www.youtube.com/channel/UCrSnFvrTO8j3fjuwrQLC4XA",
                "youtube",
            ],
        ],
        img: "fib",
    },
    {
        id: 3,
        namaOspek: "PKKMB FILKOM 2021",
        desc: "PK2MABA - Pengenalan Kehidupan Kampus bagi Mahasiswa Baru Fakultas Ilmu Komputer selanjutnya disingkat PK2MABA FILKOM adalah suatu kegiatan yang memberikan pembekalan kepada mahasiswa tentang kehidupan kampus, baik dari segi akademik maupun non akademik. STARTUP ACADEMY - Merupakan kelanjutan setelah PK2MABA FILKOM yang memfasilitasi mahasiswa dalam pembinaan karya ilmiah, pengenalan organisasi mahasiswa, dan pelaksanaan krida mahasiswa tingkat Program Studi.",
        sosmed: [
            ["https://www.instagram.com/pk2maba_filkom/", "instagram"],
            ["https://line.me/ti/p/~@sfz6895o", "line"],
            [
                "https://www.youtube.com/channel/UCWYAEA_kuJ9243vwVOecGQg",
                "youtube",
            ],
        ],
        img: "filkom",
    },
    {
        id: 4,
        namaOspek: "PKKMB FKG 2021",
        desc: "PROBINMABA (Program Pembinaan Mahasiswa Baru) merupakan pengenalan dan orientasi yang diadakan oleh FKG UB. PROBINMABA memiliki tujuan memperkenalkan mahasiswa baru FKG UB mengenai kehidupan kampus dan mempersiapkan mahasiswa baru FKG UB 2021 untuk menjadi penerus KM FKG UB dan calon tenaga kesehatan yang berintegritas, berjiwa altruistik, dan visioner dengan berlandaskan nilai-nilai KM FKG UB.",
        sosmed: [
            ["https://www.instagram.com/probinmabafkgub/", "instagram"],
            ["https://line.me/ti/p/~@iiu6843v", "line"],
        ],
        img: "fkg",
    },
    {
        id: 5,
        namaOspek: "PKKMB Vokasi 2021",
        desc: "Yuwaraja merupakan pengenalan kehidupan kampus mahasiswa baru yang diadakan oleh Fakultas Program Pendidikan Vokasi. Tema yang diangkat pada tahun ini adalah “ Derap Langkah Harmoni Membangun Vokasi Untuk Negeri”. Pada kegiatan Yuwaraja ini memiliki tujuan untuk memberi pembekalan kepada mahasiswa baru tentang kehidupan kampus serta membentuk dan mencetak seorang praktisi-praktisi muda yang Tangguh yang mempunyai jiwa pantang menyerah, berinovasi, mampu berpikir kritis serta mempunyai jiwa cinta tanah air.",
        sosmed: [
            ["https://www.instagram.com/pkkmb_vokasiub/", "instagram"],
            ["https://line.me/ti/p/~@vgh3838g", "line"],
            ["http://yuwaraja.vokasi.ub.ac.id/", "website"],
        ],
        img: "vokasi",
    },
    {
        id: 6,
        namaOspek: "PKKMB FMIPA 2021",
        desc: "PROBINMABA merupakan Kegiatan untuk mahasiswa baru FMIPA UB 2021 dalam rangka pemberian pembekalan atau arahan dan penanaman nilai kepada mahasiswa baru FMIPA UB 2021 agar dapat beradaptasi dalam kehidupan kampus dengan bentuk kegiatan berupa webinar, penugasan, praktik diskusi, apresiasi serta video inspirasi dan inaugurasi sebagai acara penutup.      ",
        sosmed: [
            ["https://www.instagram.com/probinmabafmipa/", "instagram"],
            ["https://line.me/ti/p/~@440oataq", "line"],
            ["http://mipa.ub.ac.id/", "website"],
        ],
        img: "fmipa",
    },
    {
        id: 7,
        namaOspek: "PKKMB FK 2021",
        desc: "PROBINMABA FK UB merupakan kegiatan tahunan yang diadakan untuk pembinaan mahasiswa baru. PROBINMABA FK UB sendiri, terdiri dari 2 rangkaian utama yaitu PKKMB (Pengenalan Kehidupan Kampus Mahasiswa Baru) dan BKM (Bina Karakter Mahasiswa). Tema yang diangkat pada tahun ini adalah “Menjadikan Mahasiswa Baru FK UB yang Berintegritas dengan Mengimplementasikan 4 Nilai Kolegium 2 Pilar Pembinaan dalam Kehidupan Kampus, Bermasyarakat, dan Bernegara”. Kegiatan ini memiliki tujuan untuk mencetak dan melatih Mahasiswa Baru FK UB menjadi calon tenaga kesehatan yang berkarakter serta berkualitas di masa yang akan datang.",
        sosmed: [
            ["https://www.instagram.com/probinmabafkub/", "instagram"],
            ["https://line.me/ti/p/~@bemfkub", "line"],
            [
                "https://www.youtube.com/channel/UCDq_bytxOQA8cHVQqDjFx3Q",
                "youtube",
            ],
        ],
        img: "fk",
    },
    {
        id: 8,
        namaOspek: "PKKMB PSDKU 2021",
        desc: "PKKMB PSDKU UB Kediri merupakan kegiatan pengenalan kehidupan kampus mahasiswa baru yang dilaksanakan oleh PSDKU UB Kediri. Tema besar yang diambil dari kegiatan ini adalah “Mengembangkan Potensi dan Pola Pikir Kritis Guna Mencetak Mahasiswa Penerus Bangsa yang Kreatif, Inovatif, Dinamis, Bermoral, dan Berdaya Saing Tinggi di Era Digital” kegiatan PKKMB ini memiliki tujuan yang diantaranya memberikan gambaran mengenai kehidupan kampus dan mencetak mahasiswa baru yang berintegritas dan mampu menerapkan nilai-nilai mahasiswa sehingga dapat memberikan manfaat bagi lingkungan sekitar.",
        sosmed: [
            ["https://www.instagram.com/official_pkkmbpsdkuub/", "instagram"],
            ["https://line.me/ti/p/~@tna4495f", "line"],
            [
                "https://www.youtube.com/channel/UCBDnFmO_VKcX9q3Y7oc-l5Q",
                "youtube",
            ],
        ],
        img: "kediri",
    },
    {
        id: 9,
        namaOspek: "PKKMABA FISIP 2021",
        desc: "Pengenalan Kehidupan Kampus Mahasiswa Baru Fakultas Ilmu Sosial dan Ilmu Politik Universitas Brawijaya (PKKMABA FISIP UB) merupakan kegiatan pengenalan dan orientasi yang dilakukan rutin setiap tahun. Kegiatan PKKMABA FISIP UB memiliki tujuan untuk memberikan pembekalan kepada mahasiswa baru agar dapat lebih cepat beradaptasi dengan lingkungan kampus, khususnya kegiatan pembelajaran dan kemahasiswaan serta bertujuan membentuk karakter setiap mahasiswa baru yang peka terhadap lingkungan kehidupan berbangsa dan bernegara. PKKMABA FISIP UB sejatinya merupakan langkah awal bagi mahasiswa baru guna mengenal lebih dalam dinamika kampus sehingga kegiatan ini mutlak harus diikuti oleh setiap mahasiswa baru. Adapun tema yang diangkat PKKMABA FISIP UB tahun ini adalah “Sumebyar Karsa Laksana”.",
        sosmed: [
            ["https://www.instagram.com/pkkmaba.fisipub/", "instagram"],
            ["https://line.me/ti/p/~@kesatriafisipub", "line"],
            [
                "https://www.youtube.com/channel/UCVi38OeVFhEVe5VhBNpfnWA",
                "youtube",
            ],
        ],
        img: "fisip",
    },
    {
        id: 10,
        namaOspek: "PKKMB FPIK 2021",
        desc: "Pekan Pengenalan Lingkungan dan Studi Perikanan Ilmu Kelautan atau yang biasa dikenal dengan PINISHI merupakan gerbang awal bagi mahasiswa baru Fakultas Perikanan dan Ilmu Kelautan Universitas Brawijaya Malang. PINISHI memiliki 5 rangkaian acara utama yakni PKKMABA (Ordik dan ormawa), Krima (Krida Mahasiswa), Bazar KWU, Inagurasi dan FCC PKKMABA se-Indonesia. PINISHI diharapkan menjadi rangkaian acara yang mampu memperkenalkan lingkungan perkuliahan dan membentuk mahasiswa baru dengan karakter yang berlandaskan tri dharma perguruan tinggi.",
        sosmed: [
            ["https://www.instagram.com/pinishi2021/", "instagram"],
            ["https://line.me/ti/p/~@igq6132i", "line"],
            [
                "https://www.youtube.com/channel/UC9ZR4eJiVuiqUodS0CSnx2w",
                "youtube",
            ],
        ],
        img: "fpik",
    },
    {
        id: 11,
        namaOspek: "PKKMABA FAPET 2021",
        desc: 'PKKMABA (Pengenalan Kehidupan Kampus Mahasiswa Baru) merupakan kegiatan untuk memperkenalkan kehidupan kampus Fakultas Peternakan UB kepada mahasiswa baru. Pada PKKMABA tahun ini tema yang diangkat adalah "Integritas Fakultas Peternakan Wujudkan Mahasiswa Baru yang Berjiwa Sosial, Kreatif, Inovatif, Unggul serta Bangga Terhadap Fakultas Peternakan". Kegiatan PKKMABA bertujuan untuk merangkul dan membimbing seluruh mahasiswa baru sehingga diharapkan dapat mencetak mahasiswa baru yang "Mahiiya Wistara Eunonia", yaitu sebagai seorang putra bumi yang pandai berpikiran jelas, luas, dan maju.',
        sosmed: [
            ["https://www.instagram.com/maba_fapetub/", "instagram"],
            ["https://line.me/ti/p/~@mqp5292r", "line"],
            ["http://fapet.ub.ac.id", "website"],
        ],
        img: "fapet",
    },
    {
        id: 12,
        namaOspek: "PKKMB FTP 2021",
        desc: "Pengenalan Kehidupan Kampus Fakultas Teknologi Pertanian (PKK FTP) atau disebut Rangkaian Jelajah Almamater Berwawasan Lingkungan Fakultas Teknologi Pertanian (RAJAWALI FTP) merupakan kegiatan yang bertujuan untuk memperkenalkan dunia perkuliahan dan memberikan arahan tentang proses pembelajaran yang sangat berbeda dengan bangku sekolah. Tema yang diangkat pada RAJAWALI FTP 2021 adalah “Internalisasi Nilai-Nilai Pendidikan untuk Membangun Karakter Muda yang Adaptif, Bermoral, dan Berintegritas serta Memiliki Jiwa Kepemimpinan sehingga Mampu Berkontribusi secara Nyata bagi Almamater FTP”",
        sosmed: [
            ["https://www.instagram.com/rajawaliftpub/", "instagram"],
            ["https://line.me/ti/p/~@plz6322z", "line"],
            [
                "https://www.youtube.com/channel/UChfjqtyt8_ZdCI2RGTe4BUw",
                "youtube",
            ],
        ],
        img: "ftp",
    },
    {
        id: 13,
        namaOspek: "PKKMB FP 2021",
        desc: "POSTER FP UB merupakan pengenalan orientasi yang diadakan oleh Fakultas Pertanian Universitas Brawijaya. Tema yang diangkat pada tahun ini adalah “Menjadi Mahasiswa Pertanian yang Mandiri, Unggul, cerDas dan beretikA dalam merdeka belajar untuk membangun masa depan bangsa. Kegiatan POSTER FP UB memiliki tujuan untuk mencetak, membentuk, dan mengarahkan mahasiswa baru Fakultas Pertanian Universitas Brawijaya agar menjadi insan dan mahasiswa yang unggul, cerdas , dan beretika. ",
        sosmed: [
            ["https://www.instagram.com/posterfpub/", "instagram"],
            ["https://line.me/ti/p/~@260jmlfk", "line"],
            ["https://youtube.com/channel/UC-Gpp6N28xGv-Ir7H7ql1Tg", "youtube"],
        ],
        img: "fp",
    },
    {
        id: 14,
        namaOspek: "PKKMABA FEB 2021",
        desc: "PKK-MABA FEB UB adalah sarana yang diperuntukkan mahasiswa baru dengan memiliki esensi untuk menyiapkan mahasiswa baru melewati proses transisi menjadi mahasiswa yang dewasa dan mandiri, mempercepat proses adaptasi mahasiswa dengan lingkungan yang baru, dan memberikan bekal untuk keberhasilan menempuh pendidikan di Perguruan Tinggi.PKK-MABA FEB UB 2021 membawa nama Alteration yang hadir untuk menjadikan generasi baru yang dapat beradaptasi dengan perubahan dengan tema “ALTERATION : Action Change Leaders to Adapt for Better Generation” yang akan membantu mahasiswa baru untuk adaptif dan bisa bertahan dengan perubahan serta mengembangkan generasi muda untuk menjadi pemimpin harapan bangsa di masa depan yang akan dibalut dengan 5 nilai utama yaitu  Intelektualitas, Etika, Nasionalisme, Sinergis, dan Dinamis.",
        sosmed: [
            ["https://www.instagram.com/alterationfebub/", "instagram"],
            ["https://line.me/ti/p/~@502uepts", "line"],
            [
                "https://www.youtube.com/channel/UCxNvK6LZ6Ng1bFylzchTHAQ",
                "youtube",
            ],
        ],
        img: "feb",
    },
    {
        id: 15,
        namaOspek: "PKKMB FIA 2021",
        desc: "PKKMB (Pengenalan Kehidupan Kampus Mahasiswa Baru) FIA UB 2021 merupakan kegiatan pengenalan kehidupan kampus yang dilaksanakan atau diselenggarakan oleh Fakultas Ilmu Administrasi Universitas Brawijaya. Nama PKKMB FIA UB tahun ini adalah NAWASENA 2021 yang berasal dari bahasa Sansekerta dengan arti masa depan yang cerah. Tujuan dari PKKMB FIA UB adalah membina dan memperkenalkan mahasiswa baru pada kegiatan akademik dan kemahasiswaan agar mahasiswa lebih mudah untuk beradaptasi dengan kehidupan perguruan tinggi di FIA UB.",
        sosmed: [
            ["https://www.instagram.com/pkkmb_fiaub/", "instagram"],
            ["https://line.me/ti/p/~@uwi8968b", "line"],
            [
                "https://www.youtube.com/channel/UCXPdtgZPpnu5tgTibRKv_4w",
                "youtube",
            ],
        ],
        img: "fia",
    },
    {
        id: 16,
        namaOspek: "PKKMABA FH 2021",
        desc: "Pengenalan Kehidupan Kampus Mahasiswa Baru atau biasa disingkat dengan PKKMABA adalah salah satu rangkaian pengenalan kehidupan kampus khususnya di Fakultas Hukum Universitas Brawijaya. Pada tahun ini PKKMABA FH UB 2021 bernama Intelligére yang berasal dari bahasa latin yakni Intelektual. Intelligére memiliki arti memahami dan cerdas. Dalam hal ini mahasiswa hukum diharapkan mampu menggunakan kecerdasannya dalam belajar, mengagas, dan menjawab persoalan. Sekaligus gerbang awal mahasiswa baru untuk bisa berproses dan menjadi insan intelegensia yang memiliki nilai nilai tri dharma perguruan tinggi.",
        sosmed: [
            ["https://www.instagram.com/pk2maba.fhub/", "instagram"],
            ["http://hukum.ub.ac.id", "website"],
            [
                "https://www.youtube.com/channel/UCpAWdTgQDw7s3buo6KZyTgA",
                "youtube",
            ],
        ],
        img: "fh",
    },
    {
        id: 17,
        namaOspek: "PKKMABA FT 2021",
        desc: "Deskripsi untuk PKKMABA Fakultas Teknik Universitas Brawijaya tidak tersedia saat ini.",
        sosmed: [],
        img: "ft",
    },
];
